import { Icon } from '@eduzz/ui-antd-theme';
import { Topbar } from '@eduzz/ui-layout';

import { STORE_URL } from 'settings';

const Store = () => {
  return (
    <Topbar.Action
      id='topbar-action-store'
      aria-label='Ícone de carrinho para a Loja de Apps Eduzz'
      icon={<Icon.ShoppingCart />}
      tooltip='Store'
      onClick={() => window.open(STORE_URL, '_blank')}
    />
  );
};

export default Store;
